<script lang="ts">
	import DynamicPage from '#lib/components/DynamicPage.svelte';

	let { data } = $props();
</script>

<svelte:head>
	<title>Tigers Paternion | {data.page.title}</title>
	<meta
		name="description"
		content="Website der Eishockey Clubs Tigers Paternion und Wildcats Paternion"
	/>
</svelte:head>

<DynamicPage page={data.page} />
